import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { Components as ReactSelectComponents } from './select.style';
import { Box } from '..';
import { ClearIndicator, DropdownIndicator, LoadingIndicator } from './CommonComponents/CommonComponents';
const createOption = label => ({
  id: label.toLowerCase().replace(/\W/g, ''),
  label,
  value: label.toLowerCase().replace(/\W/g, '')
});
const CreatableReactSelect = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
      disabled,
      fit = 'medium',
      isLoading = false,
      options = [],
      value,
      onChange,
      onOptionUpdate,
      customCreateOption,
      isMulti
    } = _a,
    rest = __rest(_a, ["disabled", "fit", "isLoading", "options", "value", "onChange", "onOptionUpdate", "customCreateOption", "isMulti"]);
  const [optionsIsLoading, setIsLoading] = useState(isLoading);
  const [optionsList, setOptions] = useState(options);
  const [defaultValue, setValue] = useState(value || []);
  const handleCreate = inputValue => {
    setIsLoading(true);
    const newOption = customCreateOption ? customCreateOption(inputValue) : createOption(inputValue);
    setTimeout(() => {
      setIsLoading(false);
      setOptions(prev => [].concat(_toConsumableArray(prev), [newOption]));
      setValue(prev => isMulti ? [].concat(_toConsumableArray(prev), [newOption]) : [newOption]);
    }, 1000);
    if (onOptionUpdate) {
      onOptionUpdate(newOption);
    }
  };
  const handleChange = val => {
    setValue(val);
    if (typeof onChange === 'function') {
      onChange(val);
    }
  };
  return _jsx(ReactSelectComponents.RefWrapper, _extends({
    ref: ref
  }, {
    children: _jsx(Box, _extends({
      flex: "1",
      position: "relative"
    }, {
      children: _jsx(ReactSelectComponents.CreatableReactSelect, _extends({
        components: {
          LoadingIndicator: () => _jsx(LoadingIndicator, {
            fit: fit,
            disabled: disabled
          }),
          DropdownIndicator: props => _jsx(DropdownIndicator, _extends({}, props)),
          ClearIndicator: props => _jsx(ClearIndicator, _extends({}, props, {
            fit: fit,
            disabled: disabled
          }))
        },
        classNamePrefix: "MultiSelect",
        fit: fit,
        isDisabled: optionsIsLoading || disabled,
        isLoading: optionsIsLoading,
        onChange: newValue => handleChange(newValue),
        onCreateOption: handleCreate,
        options: optionsList,
        value: defaultValue,
        isMulti: isMulti
      }, rest, {
        isSearchable: true
      }))
    }))
  }));
});
export default CreatableReactSelect;